import gql from 'graphql-tag';
import get from 'lodash/get';

import { MyMockExamResultFragmentV2 } from '../fragments/MockExamFragment';

export const getMXRSections = data => {
  return get(data, 'mockExamResult.sectionData.sections');
};

export const getMyMXRSections = data => {
  return get(data, 'myMockExamResult.sectionData.sections');
};

export const queryMockExamResult = gql`
  query mockExamResult($mockExamId: ID!, $examCardId: ID!) {
    mockExamResult(mockExamId: $mockExamId) {
      id
      examId
      fullScore
      minimumScore
      maximumScore
      averageScore
      sdScore
      sectionData {
        id
        sections {
          id
          title
          maximumScore
          minimumScore
          fullScore
          averageScore
          sdScore
          subsections {
            id
            title
            maximumScore
            minimumScore
            fullScore
            averageScore
            sdScore
            topics {
              id
              title
              maximumScore
              minimumScore
              fullScore
              averageScore
              sdScore
            }
          }
        }
      }
    }
    myMockExamResult(examCardId: $examCardId) {
      id
      ...MyMockExamResultFragmentV2
      sectionData {
        id
        sections {
          id
          title
          ...MyMockExamResultFragmentV2
          subsections {
            id
            title
            ...MyMockExamResultFragmentV2
            topics {
              id
              title
              ...MyMockExamResultFragmentV2
            }
          }
        }
      }
    }
  }
  ${MyMockExamResultFragmentV2}
`;
